import { useLayoutEffect } from "react";

const useBrowserLayoutEffect =
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  typeof window !== "undefined" ? useLayoutEffect : () => {};

export default useBrowserLayoutEffect;
